module.exports = __webpack_public_path__ + "img/circle.b7b550ec.svg";